import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=79206e2d&scoped=true"
import script from "./AttachmentList.vue?vue&type=script&lang=js"
export * from "./AttachmentList.vue?vue&type=script&lang=js"
import style0 from "./AttachmentList.vue?vue&type=style&index=0&id=79206e2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79206e2d",
  null
  
)

export default component.exports